// extracted by mini-css-extract-plugin
module.exports = {"overview":"Home_overview__3wGz5"};